"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeInForceForOrderType = void 0;
var timeInForceForOrderType = exports.timeInForceForOrderType = {
  'Reserve Order': 0,
  'Good till Cancel': 1,
  'Immediate or Cancel': 3,
  'Fill Or Kill': 4
};